import React from 'react'
import { Stack } from '@mui/material'

import { Country } from 'constants/country'
import { AddressMap, AddressMapContextProvider } from 'components/common/AdressMap'
import { AutocompleteInput } from 'components/common/AdressMap/AutocompleteInput'
import { LoadMapScriptWrapper } from 'components/common/AdressMap/LoadMapScriptWrapper'

import { placeToKeyPickupFields } from '../../meeting.helpers'

interface Props {
  initialAddress?: string
  initialMarker?: { lat: number; lng: number }
  center?: { lat: number; lng: number }
  countryCode?: string
  language: string
  onPlaceChange: (fields: ReturnType<typeof placeToKeyPickupFields>) => void
}

/**
 * The key-pickup address: autocomplete and map sharing one `AddressMapContextProvider`, so the pick is
 * geocoded into the routable coordinates the order needs.
 */
export const KeyPickupAddressField: React.FC<Props> = ({
  initialAddress,
  initialMarker,
  center,
  countryCode,
  language,
  onPlaceChange,
}) => (
  <AddressMapContextProvider>
    <LoadMapScriptWrapper language={language} countryCode={countryCode}>
      <Stack gap={1.2}>

        <AutocompleteInput
          restrictToCountries={countryCode}
          handleChange={(place, isInitialLookup) => {
            if (!isInitialLookup) onPlaceChange(placeToKeyPickupFields(place))
          }}
        />

        <AddressMap
          height="24rem"
          center={center}
          language={language}
          countryCode={countryCode || Country.CH}
          initialAddress={initialAddress}
          initialMarker={initialMarker}
          handleChange={(place, isInitialLookup) => {
            if (!isInitialLookup) onPlaceChange(placeToKeyPickupFields(place))
          }}
        />

      </Stack>
    </LoadMapScriptWrapper>
  </AddressMapContextProvider>
)
